import styled from 'styled-components';

export const StyledComponentsListWrapper = styled.div`
  position: relative;

  .MuiAccordion-root:before {
    height: 0;
  }
`;
